import { ColDef } from '@ag-grid-enterprise/all-modules'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { NotificationType } from '@/modules/configurationModule/detail/notifications/models/notification-types'
import { getEnumColumnGridOptions } from '@/grid/base-grid-options'
import { VtGridTextFormatter } from '@/grid/vt-grid-text-formatter'
import { EntityStatusState } from '@/store/root/root-store.model'

export const notificationTypesGridColumnDefs =
    (notificationTypes: NotificationType[]): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            ...getEnumColumnGridOptions(notificationTypes, 'code', 'name'),
            filterParams: {
                ...getEnumColumnGridOptions(notificationTypes, 'code', 'name').filterParams,
                textFormatter: (from: string) => VtGridTextFormatter.entityStatusStateFormatter(from, notificationTypes as EntityStatusState[])
            },
            headerName: i18n.tc('configuration.grid.type'),
            colId: 'notificationType',
            field: 'notificationType.name',
            minWidth: 400,
            flex: 2
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.application'),
            field: 'inboxChannelActive',
            flex: 1,
            minWidth: 80
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.email'),
            field: 'emailChannelActive',
            flex: 1,
            minWidth: 80
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.sms'),
            field: 'smsChannelActive',
            flex: 1,
            minWidth: 80
        }
    ]
